import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { getDraftShareIdFromQueryParam } from '@confluence/route-manager-utils/entry-points/getDraftShareIdFromQueryParam.ts';

import useEmojiEverSetPropertyQuery from './emoji-title/__generated__/useEmojiEverSetPropertyQuery.graphql.ts';

export const preloadEmojiEverSetProperty = (contentId: string) => {
	return query({
		query: useEmojiEverSetPropertyQuery,
		variables: {
			contentId,
			status: ['current', 'draft'],
			draftShareId: getDraftShareIdFromQueryParam(),
		},
	});
};
